import React from 'react';
import { Container } from './ui/Container';
import { BonoItem } from './BonoItem';
import { bonos, kitExtras } from '../data/bonos';
export function BonosSection() {
  return <section className="bg-mp-dark py-16 md:py-24 border-t border-mp-border" data-id="element-43" data-mp="13dxlvkgcsl7g">
      <Container data-id="element-44" data-mp="13bte2rfc321w">
        <div className="max-w-[700px]" data-id="element-45" data-mp="yeumafj5776v">
          <p className="font-heading text-xs uppercase tracking-[0.2em] text-mp-electric" data-id="element-46" data-mp="ye1k7rv4p5v2">
            Los 5 bonos de implementación
          </p>
          <p className="mt-1 text-sm text-mp-gray" data-id="element-47" data-mp="tddmknce9qrv">Incluidos gratis en cualquiera de las dos versiones.</p>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-48" data-mp="kejqcy2z72eu">
          {bonos.map((bono, index) => <BonoItem key={bono.number} bono={bono} index={index} data-id="element-49" data-mp="fh0axuujkjlb" data-mpi={index} />)}
        </div>

        <div className="mx-auto mt-14 max-w-[700px] rounded-2xl border border-mp-lime/30 bg-mp-card p-6 text-center md:p-7" data-id="element-50" data-mp="2es1jd0m5grh9">
          <p className="font-heading text-xs uppercase tracking-[0.2em] text-mp-lime" data-id="element-51" data-mp="29urjer14wxf6">
            Kit de Ejecución — solo en Maestro en Pista + Kit de Ejecución
          </p>
          <p className="mt-2 text-sm leading-relaxed text-mp-gray" data-id="element-52" data-mp="vvkbji80s4ul">
            Por solo 5€ más que la versión base, añades las dos herramientas que convierten el sistema en una
            temporada completamente planificada.
          </p>
        </div>

        <div className="mx-auto mt-6 grid max-w-[700px] grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-53" data-mp="1ajdmgpm5uj6u">
          {kitExtras.map((bono, index) => <BonoItem key={bono.number} bono={bono} index={index} data-id="element-54" data-mp="1ejxj7s2tnksg" data-mpi={index} />)}
        </div>
      </Container>
    </section>;
}